/* v8 ignore file -- @preserve */
/**
 * Defines the view types for different screen sizes.
 * @enum {string}
 */
const viewTypes = {
  desktop: 'Desktop',
  mobile: 'Mobile',
};

/**
 * Defines the device types used in API requests.
 * @enum {string}
 */
const deviceTypes = {
  desktop: 'DESKTOP',
  phone: 'PHONE',
};

/**
 * Maps view types to their corresponding device types.
 * @type {{Desktop: 'DESKTOP', Mobile: 'PHONE'}}
 */
const viewTypeToDeviceType = {
  [viewTypes.desktop]: deviceTypes.desktop,
  [viewTypes.mobile]: deviceTypes.phone,
};

/**
 * Default context values for navigation.
 * @type {{viewType: string, deviceType: string, regionCode: string, currencyCode: string}}
 */
const defaultContext = {
  viewType: 'Default',
  deviceType: 'DESKTOP',
  regionCode: 'US',
  currencyCode: 'USD',
};

/**
 * Represents the operational states of a store.
 * @enum {string}
 */
const storeOperationStates = {
  OPEN: 'open',
  CLOSE: 'close',
};

/**
 * The minimum screen width in pixels to be considered a desktop view.
 * @type {number}
 */
const DESKTOP_MINIMUM_SCREEN_WIDTH = 1024;

/**
 * The maximum number of items to display in the shopping bag count.
 * @type {number}
 */
const MAX_BAG_COUNT = 99;

/**
 * Variations of link text for paying a credit card bill.
 * @type {string[]}
 */
const PAY_BILL_LINK_TEXT_VARIATIONS = ['pay your credit card bill', 'pay my bill'];

/**
 * URL prefixes for different types of search pages.
 * @type {{featured: string, keyword: string}}
 */
const SEARCH_PAGE_PREFIXES = {
  featured: '/shop/featured/',
  keyword: '/shop/search?keyword=',
};

/**
 * Defines the types of fallbacks available for XAPI failures.
 * @enum {string}
 */
const fallbackTypes = {
  header: 'header',
  footer: 'footer',
};

export {
  fallbackTypes,
  deviceTypes,
  viewTypes,
  viewTypeToDeviceType,
  defaultContext,
  storeOperationStates,
  DESKTOP_MINIMUM_SCREEN_WIDTH,
  MAX_BAG_COUNT,
  PAY_BILL_LINK_TEXT_VARIATIONS,
  SEARCH_PAGE_PREFIXES,
};
